import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Hero from './Hero';
import TopBar from '../../components/layout/main/TopBar';
import Features from './Features';
import Team from './Team';
import Highlights from './Highlights';
import FAQ from './FAQ';
import Footer from '../../components/layout/main/Footer'
import { Stack } from '@mui/material';
import Brands from './Brands';
import React from 'react';
import MediaInkSection from 'components/MediaInkSections';
import Sdk from './Sdk';


export default function Landing(props) {



  return (
    <>
      <CssBaseline />
      <Stack sx={{ bgcolor: 'background.default' }}>
        <Hero />
        <Divider />
        <Sdk></Sdk>
        <Divider />
        <Team />
        <Divider />
        <Features />
        <Divider />
        <Highlights />
        <Divider />
        <FAQ />
      </Stack>
    </>
  );
}